<template>
    <div class="wrapper">
        <div class="card">
            <section v-if="showTfaAppSetup">
                <tfa-app-setup class="tfa-setup" :onCancel="onTfaAppSetupCancel" :onComplete="onTfaAppSetupComplete"/>
            </section>

            <section v-if="showChangePassword" id="password-change">
                <label>Change password</label>
                <change-password :onCancel="onPasswordChangeCancel" :onComplete="onPasswordChangeComplete"/>
            </section>

            <div v-if="!showTfaAppSetup && !showChangePassword" class="section-wrapper">
                <h2>{{user.name}}</h2>
                <section>
                    <label>Change password</label>
                    <button class="primary" @click="showChangePassword = true">Change</button>
                </section>
                <section>
                    <label>Reset 2Factor Authentication</label>
                    <button class="primary" @click="showTfaAppSetup = true">Reset</button>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import changePassword from '@/components/changePassword';
import tfaAppSetup from '@/components/2fa/setup/tfaAppSetup';

export default {
    name: 'profile',
    mixins: [
        Default
    ],
    components: {
        changePassword,
        tfaAppSetup
    },
    data() {
        return {
            showTfaAppSetup: false,
            showChangePassword: false
        };
    },
    computed: {
        user: {
            get() {
                return this.$store.getters[this.$store.types.user.getters.get];
            }
        }
    },
    methods: {
        onPasswordChangeComplete: function() {
            this.$parleyAdmin.queryErrors.addError('Password changed successfully', this.$parleyAdmin.queryErrors.TYPE_SUCCESS);
            this.showChangePassword = false;
        },
        onPasswordChangeCancel: function() {
            this.showChangePassword = false;
        },
        onTfaAppSetupCancel: function() {
            this.showTfaAppSetup = false;
        },
        onTfaAppSetupComplete: function() {
            this.showTfaAppSetup = false;
            this.$parleyAdmin.queryErrors.addError('2 Factor Authentication changed successfully', this.$parleyAdmin.queryErrors.TYPE_SUCCESS);
        }
    }
};
</script>

<style lang="scss" scoped>
    .wrapper {
        height: calc(100vh - #{$topBarHeight});
        overflow-y: auto;

        .card {
            background-color: white;
            -webkit-box-shadow: 0 7px 20px 3px #e8ebf0;
            -moz-box-shadow: 0 7px 20px 3px #e8ebf0;
            box-shadow: 0 7px 20px 3px #e8ebf0;
            border-radius: 8px;
            margin: 3em auto;
            display: table;
            /*height: auto;*/
            height: auto;
            overflow: hidden;

            .tfa-setup {
                width: 70em;
                min-height: 42em;
                /*position: absolute;*/
                /*top: 0;*/
                /*left: 0;*/
                background-color: white;
                padding: 3em 6em 0 6em;
            }

            #password-change {
                margin: 2em 2em 5em 2em;
            }

            .section-wrapper {
                padding: 3em 6em;

                section {
                    margin-bottom: 3em;
                    overflow: hidden;

                    &:last-of-type {
                        margin-bottom: 0;
                    }

                    .input-name {
                        width: 20em;
                        padding-bottom: 0;
                    }

                    button {
                        height: 3em;
                        padding: .5em;
                        width: 12em;
                        line-height: inherit;
                    }
                }
            }
        }
    }
</style>